import React, { useContext } from 'react';
import { ModalContext, CustomFooter, EMPTY_OBJECT } from 'commons-ui';

import { MISCELLANEOUS_RESOURCES, PAGE_NAMES } from 'constant';
import Reject from '../submodules/reject';
import useHandlers from './useHandlers';

export const makeActionHandler = (action: any, params: any) => {
	const { setModalConfig } = useContext(ModalContext);
	const { rowData = EMPTY_OBJECT, history, fetchConfiscationAndRefundData } = params;
	const { onAgreeConfiscationAndRefund, onDisAgreeConfiscationAndRefund } = useHandlers(params);

	switch (action.id) {
		case 'add':
			return () => {
				history.push({
					pathname: `/${PAGE_NAMES.miscellaneous}/${MISCELLANEOUS_RESOURCES.confiscationAndRefund}/selectConfiscation`
				});
			};
		case 'approve':
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'Action confirmation',
					content: 'Are you sure you want to approve the confiscation request?',
					footer: (
						<CustomFooter onAgreeClick={onAgreeConfiscationAndRefund} onDisagreeClick={onDisAgreeConfiscationAndRefund} />
					)
				});
			};
		case 'reject':
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'Reject confiscation and refund request',
					content: <Reject rowData={rowData} fetchConfiscationAndRefundData={fetchConfiscationAndRefundData} />
				});
			};

		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
